import React from 'react';
import { useNavigate } from 'react-router';

const WorkflowRow = ({ id, name, moduleName, className }) => {

    const navigate = useNavigate();

    const handleClickRow = () => {
        navigate('/workflow/' + id);
    };

    return (
        <>
            {
                name ?
                <tr onClick={handleClickRow} className={className}>
                    <td>{moduleName}</td>
                    <td>{name}</td>
                </tr> :
                null
            }
        </>
    )   
}

export default WorkflowRow;